module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4NSIgaGVpZ2h0PSI2OCIgdmlld0JveD0iMCAwIDg1IDY4Ij4KICA8dGV4dCBmaWxsPSIjMUU2MUZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZvbnQtZmFtaWx5PSJHZW9yZ2lhIiBmb250LXNpemU9IjI1NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTkgLTM3MikiPgogICAgPHRzcGFuIHg9IjAiIHk9IjU2MyI+4oCcPC90c3Bhbj4KICA8L3RleHQ+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./icons/quote.svg
// module id = 51
// module chunks = 0